module.exports = __webpack_public_path__ + "img/GNO.9dfca219.svg";